var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteArrow = function SvgWhiteArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M15.27 4.35a.5.5 0 0 0 0-.7L12.09.46a.5.5 0 1 0-.71.71L14.2 4l-2.83 2.83a.5.5 0 1 0 .7.7l3.19-3.18ZM.42 4.5h14.5v-1H.41v1Z"
  })));
};
export default SvgWhiteArrow;